@if (item && !item.dynamic && uiState) {
  <li
    [asgReadAloud]
    [asgClickHandler]="item.click"
    [asgClickParams]="item.feature"
    [asgardFeature]="item.feature"
    (click)="clicked()"
  [ngClass]="{
      'disabled': uiState[item.feature].disabled,
      'hidden': uiState[item.feature].hidden,
      'locked': uiState[item.feature].locked,
      'as-has-dropdown': (item.children && item.children.length),
      'active': uiState[item.feature].active
      }" class="asg-desktop-menu-item">
    <a>
      @if (item.image) {
        <img [src]="item.image" alt="" class="asg-desktop-menu-item__image" aria-hidden="true">
      } @else if (item.icon) {
        <i [ngClass]="item.icon"></i>
      }
      @if (item && item.title && item.isChild) {
        <span>{{ item.title | translate: currentCloudParam ? (currentCloudParam | async) : '' }}</span>
      }
    </a>
    @if (item.children && item.children.length) {
      <ul aria-label="submenu" class="asg-desktop-menu as-dropdown as-dropdown--top">
        @for (subchild of item.children; track subchild) {
          <asg-desktop-menu-item [item]="subchild" [uiState]="uiState"></asg-desktop-menu-item>
        }
      </ul>
    }
  </li>
}

@if (item && item.dynamic) {
  <li class="asg-desktop-menu-item" (click)="clicked()" [asgReadAloud]>
    <ng-template asgComponentBuilder [componentData]="item.componentData" [feature]="item.feature" [BuildComponent]="item.component">
    </ng-template>
  </li>
}
